import { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./style.scss";
import { useNavigate } from "react-router";
import arrow from "./img/Arrow.svg";
import { useWindowSize } from "../../Helpers";
import Dropdown from "@components/Dropdown";
import chevron from "./img/chevron.svg";

export default function InnerNavigation({ navItems }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(null);
  const { width } = useWindowSize();
  const XGA = width >= 1020;
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location.pathname]);

  const headerText =
    navItems.find((item) => item.link === activeLink)?.name || "";

  return (
    <div className="inner-navigation-wrapper">
      {XGA ? (
        <ul className="inner-navigation-list">
          {navItems.map((item) => (
            <li key={item.link} className="inner-navigation-item-wrapper">
              <NavLink
                to={item.link}
                className="inner-navigation-item"
                onClick={(e) => {
                  if (item.redirect) {
                    e.preventDefault();
                    navigate(item.redirect);
                  }
                  setActiveLink(item.link);
                }}
              >
                <span
                  className={`inner-navigation-item-name  ${
                    activeLink === item.link ? "active" : ""
                  }`}
                >
                  {activeLink === item.link ? (
                    <img alt="arrow" src={arrow} />
                  ) : (
                    <div className="line"></div>
                  )}
                  {item.name}
                </span>
              </NavLink>
            </li>
          ))}
        </ul>
      ) : (
        <div>
          <Dropdown
            absolute
            className="inner-navigation-list-mobile"
            summary={
              <div className="navigation-list-mobile-wrapper">
                <h2
                  className={`inner-section ${
                    location.pathname === activeLink
                      ? "inner-section-selected"
                      : ""
                  }`}
                >
                  <img alt="arrow" src={arrow} />
                  {headerText}
                </h2>
                <img
                  alt="chevron"
                  src={chevron}
                  className={`chevron ${dropdownOpen ? "chevron-rotated" : ""}`}
                />
              </div>
            }
            open={dropdownOpen}
            setOpen={() => {
              dropdownOpen ? setDropdownOpen(false) : setDropdownOpen(true);
            }}
            details={
              <ul className="inner-navigation-item-wrapper">
                {navItems.map((item) => (
                  <li key={item.link} className="inner-navigation-item">
                    <NavLink
                      to={item.link}
                      className="inner-navigation-item-link"
                      onClick={(e) => {
                        if (item.redirect) {
                          e.preventDefault();
                          navigate(item.redirect);
                        }
                        setActiveLink(item.link);
                        setDropdownOpen(false);
                      }}
                    >
                      <span
                        className={`inner-navigation-item-name  ${
                          activeLink === item.link ? "active" : ""
                        }`}
                      >
                        {activeLink === item.link ? (
                          <img alt="arrow" src={arrow} />
                        ) : (
                          <div className="line"></div>
                        )}
                        {item.name}
                      </span>
                    </NavLink>
                  </li>
                ))}
              </ul>
            }
          />
        </div>
      )}
    </div>
  );
}
